export default __webpack_public_path__ + "static/media/1OfU.a218fcc4.png";